import { note } from "../../lib/ui.ts";

export function Note({ children, className }: { children: React.ReactNode; className?: string }) {
  const classes = className ? `${note} ${className}` : note;
  return <div className={classes}>{children}</div>;
}
